/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum TimeUnits {
  Sec = 'sec',
  Min = 'min',
  Hour = 'hour',
}
